(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("efview", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["efview"] = factory(require("vue"));
	else
		root["efview"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_141__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition